import React from 'react'
import { isBrowser } from 'react-device-detect'
import BasicLayout from 'core/templates/BasicLayout'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from 'core/components/ui'
import img from 'assets/images'
import { font, greys } from 'assets/themes/theme-default'

const BKG = styled.div`
  position: absolute;
  background-image: ${isBrowser && `url('${img.error404BKG}')`};
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
`
const RowContentWrapper = styled(Row)`
  position: absolute;
  height: 100%;
  width: 100%;
`
const Title = styled.h2`
  color: ${greys.dark1};
  text-transform: uppercase;
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgxxl};
  margin: 65px 0 10px;
`
const SubTitle = styled.h4`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
`

const NoMatchRoute = () => (
  <BasicLayout data-test="component-no-match-route" showSider={false}>
    <BKG>
      <RowContentWrapper type="flex" align="middle">
        <Col span={12} offset={4}>
          <Title data-test="no-match-route-title">
            <FormattedMessage id="error-404-title" />
          </Title>
          <SubTitle data-test="no-match-route-subtitle">
            <FormattedMessage id="error-404-subtitle" />
          </SubTitle>
        </Col>
      </RowContentWrapper>
    </BKG>
  </BasicLayout>
)

NoMatchRoute.propTypes = {}

export default NoMatchRoute
